import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Lightbox from 'react-image-lightbox';
import cx from 'classnames';

import { withAppContext } from '../contexts/app';

class ConditionPhotographies extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      images: props.images.slice(0, 3),
      baseUrl: props.internalImages ? props.app.baseUrl : '',
      lightboxOpen: false,
      lightboxImageUrl: undefined
    };
  }

  render() {
    const showGalleryLink = (this.props.linkToGallery && this.props.galleryLink);

    return (
      <React.Fragment>
        <div id="photographies" className={`${this.props.className} condition-photographies`}>
          { this.props.title &&
            <div className="condition-photographies__head">
              <div className="condition-photographies__head__title">
                { React.createElement(this.props.titleHeaderTag, {}, this.props.title) }
              </div>

              { showGalleryLink &&
                <div className="condition-photographies__head__gallery-link">
                  <Link to={{ pathname: this.props.galleryLink, state: {
                    backButtonLabel: this.props.galleryBackButtonLabel
                  }}}>
                    {/*
                      Can't add the number of photos until data is fully move to the health repo since these images
                      come from the mutation and the gallery will load from the health repo; the number often doesn't match
                    */}
                    See all {/*this.props.images.length*/} photos
                  </Link>
                </div>
              }
            </div>
          }

          <div className="condition-photographies__images">

            { this.state.images.map((image, index) => {
              return (
                <div
                  key={index}
                  className={cx('condition-photographies__images__item', {
                    'hover-to-reveal': this.props.hoverToReveal,
                    'pointer-cursor': this.props.lightboxEnabled
                  })}
                  onClick={this.openLightbox.bind(this, image.imageUrl)}
                >
                  <div className="condition-photographies__images__image__wrapper">
                    <div
                      className="condition-photographies__images__image"
                      style={{ backgroundImage: `url(${this.state.baseUrl}${image.thumbnailUrl})` }}
                    >
                    </div>

                    { this.props.hoverToReveal &&
                      <React.Fragment>
                        <div className="condition-photographies__images__hover--mobile">Tap to reveal</div>
                        <div className="condition-photographies__images__hover--desktop">Hover to reveal</div>
                      </React.Fragment>
                    }
                  </div>

                  <div className="condition-photographies__images__title">
                    {image.title}
                  </div>
                </div>
              );
            })};

          </div>
        </div>

        { this.state.lightboxOpen && (
          <Lightbox
            mainSrc={this.state.lightboxImageUrl}
            enableZoom={false}
            onCloseRequest={this.closeLightbox.bind(this)}
          />
        )}
      </React.Fragment>
    );
  }

  openLightbox(imageUrl) {
    if (!this.props.lightboxEnabled) { return; }

    this.setState({ lightboxOpen: true, lightboxImageUrl: imageUrl });
  }

  closeLightbox() {
    this.setState({ lightboxOpen: false, lightboxImageUrl: null });
  }
}

ConditionPhotographies.defaultProps = {
  className: '',
  hoverToReveal: false,
  titleHeaderTag: 'h3',
  linkToGallery: true,
  galleryLink: undefined,
  internalImages: false,
  lightboxEnabled: false
};

ConditionPhotographies.propTypes = {
  app: PropTypes.object.isRequired,
  className: PropTypes.string,
  images: PropTypes.array.isRequired,
  title: PropTypes.string,
  titleHeaderTag: PropTypes.string,
  linkToGallery: PropTypes.bool,
  galleryLink: PropTypes.string,
  galleryBackButtonLabel: PropTypes.string,
  hoverToReveal: PropTypes.bool, // Not compatible with `lightboxEnabled`
  internalImages: PropTypes.bool,
  lightboxEnabled: PropTypes.bool // Not compatible with `hoverToReveal`
};

export { ConditionPhotographies };
export default withAppContext(ConditionPhotographies);
